import { LAMBDA_TOKEN } from '@/services/config/aws';

interface IHeaders {
  headers?: {
    'Content-Type': string;
    'Access-Control-Allow-Origin': string;
    'Access-Control-Allow-Headers': string;
    'lambda-token': string;
  };
}

export const composeHttpHeaders = () => {
  const result: IHeaders = {};

  result.headers = {
    'Content-Type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
    'lambda-token': `${LAMBDA_TOKEN}`,
  };

  return result;
};
